<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">

          <div class="row" v-if="isAdmin">
            <div class="col-12">
              <div class="float-right mb-4">
                <button class="btn btn-secondary btn-sm" @click="export2Excel">
                  <i class="fas fa-download fa-fw"></i> Download XLS
                </button>
              </div>
            </div>
          </div>

          <v-server-table
            ref="vuetable"
            url="/dtable/customers"
            :columns="columns"
            :options="options"
          >

            <!-- Título -->
            <template slot="beforeFilter">
              <h2>
                <i class="fas fa-user text-primary"></i>
                {{ $t('customer.title') }}

                <router-link
                  :to="{ name: 'customers_new' }"
                  class="btn btn-primary float-right ml-4"
                >
                  <i class="fas fa-plus fa-fw"></i>
                  {{ $t('customer.button.addnew') }}
                </router-link>
              </h2>
            </template>

            <!-- Ações -->
            <template slot="id" slot-scope="props" v-if="showIfRoleIs('admin,admin-rede')">
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'customers_edit', params: { id: props.row.id } }"
              >
                <i class="fas fa-edit fa-fw"></i>
              </router-link>

              <router-link
                v-if="isAdmin"
                class="btn btn-xs btn-primary"
                :to="{ name: 'customers_delete', params: { id: props.row.id } }"
              >
                <i class="fas fa-trash-alt fa-fw"></i>
              </router-link>
            </template>

          </v-server-table>

        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      columns: [
        "name",
        "document",
        "phone",
        "email",
        "id"
      ],
      options: {
        orderBy: {
          ascending: false,
          column: "id"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: () => this.$t("customer.name"),
          document: () => this.$t("customer.document"),
          phone: () => this.$t("customer.phone"),
          email: () => this.$t("customer.email"),
          id: ""
        },
        texts: {
          count: this.$t("field.count"),
          filter: this.$t("field.filter"),
          filterPlaceholder: this.$t("field.filterplaceholder"),
          limit: this.$t("field.limit")
        },
        columnsClasses: {
          id: "text-right"
        },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    getCurrentDate() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    },
    export2Excel() {
      import("@/excel/Export2Excel").then(excel => {
        const tHeader = ["#", "Name", "Document", "Phone", "Email"];
        const filterVal = ["id", "name", "document", "phone", "email"];
        const list = this.$refs.vuetable.data;
        const data = list.map(v => filterVal.map(j => v[j]));

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.$t("customer.title") + "_" + this.getCurrentDate(),
          autoWidth: true,
          bookType: "xlsx"
        });
      });
    }
  }
};
</script>

<style>
</style>
